import { yup } from '@guiker/yup-util'

export const nullableBoolean = yup.boolean().nullable()
